import { Dispatch } from 'redux';

import { getFeatureFlags } from 'api/featureFlags';

import { setFeatures } from './features';

export const getFeatureFlagsThunk = () => async (dispatch: Dispatch) => {
  const features = await getFeatureFlags();

  dispatch(setFeatures(features));
};
